import { render, staticRenderFns } from "./OverviewProducerSelect.vue?vue&type=template&id=4e959795&scoped=true&"
import script from "./OverviewProducerSelect.vue?vue&type=script&lang=js&"
export * from "./OverviewProducerSelect.vue?vue&type=script&lang=js&"
import style0 from "./OverviewProducerSelect.vue?vue&type=style&index=0&id=4e959795&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e959795",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VCol,VRow,VSelect})
